import type {
  INavigationControlIntegrationApi,
  INavigationController,
  INavigationControllerFactory
} from './interfaces';
import { injectable } from 'inversify';
import { NavigationController } from './NavigationController';

@injectable()
export class NavigationControllerFactory implements INavigationControllerFactory {
  public createNavigationController(integrationApi: INavigationControlIntegrationApi): INavigationController {
    return new NavigationController(integrationApi);
  }
}
